import { Outlet, Link } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { AppNavbar } from "@/components/app/AppNavbar";
import { useWallet } from "@/hooks/useWallet";
import { Button } from "@/components/ui/button";

export function AppLayout() {
  const { address, isConnected } = useWallet();

  if (!isConnected || !address) {
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-transparent to-transparent"></div>
        <div className="text-center max-w-md relative z-10">
          <div className="flex items-center justify-center mx-auto mb-8">
            <img 
              src="/sharpex-logotype-2.png" 
              alt="Sharpexio" 
              className="h-12 w-auto transition-transform duration-300 hover:scale-105"
            />
          </div>
          <h1 className="text-3xl font-bold mb-4 tracking-tight">Connect your wallet</h1>
          <p className="text-muted-foreground mb-8 text-sm leading-relaxed">
            Link your Hyperliquid wallet to view your trading analytics and performance metrics.
          </p>
          <Link to="/">
            <Button variant="hero" size="lg" className="shadow-lg shadow-primary/20">
              Go to Home
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <div className="fixed inset-0 bg-gradient-to-br from-primary/[0.02] via-transparent to-accent/[0.02] pointer-events-none"></div>
      <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/[0.03] via-transparent to-transparent pointer-events-none"></div>
      <div className="relative z-10">
        <AppNavbar />
        <Outlet />
      </div>
    </div>
  );
}
